import React, { useEffect, useState } from "react";
import HeaderCustom from "../../../components/HeaderCustom";
import { Alert, Backdrop, CircularProgress, Snackbar } from "@mui/material";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import FreeTextField from "../../../components/FreeTextField";
import EncuestaFormComponents from "../../../components/EncuestaFormComponents";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { useSelector } from "react-redux";
import dayjs from "dayjs";
import { getDetalleEncuesta, postAddEncuesta, postUpdateEncuesta } from "../../../api/ApiService";


function AddEncuestaPage() {
    const [cargando, setCargando] = useState(false);
    const [open, setOpen] = useState(false);
    const [severity, setSeverity] = useState('');
    const [mensaje, setMensaje] = useState('');
    const [loadingGuardar, setLoadingGuardar] = useState(false);
    const [editable, setEditable] = useState(false);

    const [fechaDesde, setFechaDesde] = useState(null);
    const [fechaDesdeBackend, setFechaDesdeBackend] = useState('');
    const [errorDesde, setErrorDesde] = useState(false);

    const [fechaHasta, setFechaHasta] = useState(null);
    const [fechaHastaBackend, setFechaHastaBackend] = useState('');
    const [errorHasta, setErrorHasta] = useState(false);

    const [tituloEncuesta, setTituloEncuesta] = useState("");
    const [errorTituloEncuesta, setErrorTituloEncuesta] = useState(false);
    const [optionsEncuesta, setOptionsEncuesta] = useState([
        {
            id: 1,
            label: 'Ingrese pregunta',
            value: '',
            type: 'text',
            selectorSelected: 'Selección unica',
            options: [
                {
                    id: 1,
                    label: 'Ingresar pregunta',
                    value: "",
                    type: 'radio'
                }
            ]
        },
    ]);
    const [errorOptionsLabelsValueIndexs, setErrorOptionsValueIndexs] = useState([]);
    const [errorOptionsValuesIndexs, setErrorOptionsValuesIndexs] = useState([]);
    const [errorOptionsLabelsEncuestaValueIndexs, setErrorOptionsLabelsEncuestaValueIndexs] = useState([]);

    const stateToken = useSelector(state => state.reducerGlobal.token);
    // console.log("stateToken", stateToken?.access_token);

    const params = useParams();
    const localizacion = useLocation();
    // console.log("params", localizacion);

    const navigate = useNavigate();


    useEffect(() => {
        if (params?.id) {
            setEditable(true);
            if (stateToken?.access_token) {
                getDetalleEncuesta(params.id, stateToken.access_token)
                    .then((response) => {
                        const data = response?.data || {};
                        setTituloEncuesta(data.nombre_encuesta || '');

                        if (data.fecha_inicio) {
                            const fechaInicio = data.fecha_inicio.split(' ')[0];
                            setFechaDesde(dayjs(fechaInicio));
                            setFechaDesdeBackend(fechaInicio);
                        }
                        if (data.fecha_fin) {
                            const fechaFin = data.fecha_fin.split(' ')[0];
                            setFechaHasta(dayjs(fechaFin));
                            setFechaHastaBackend(fechaFin);
                        }
                        if (data.detalles && data.detalles.length > 0) {
                            setOptionsEncuesta(data.detalles);
                        }
                        setCargando(true);
                    })
                    .catch((error) => {
                        console.log('error-getDetalleEncuesta', error);
                        setCargando(true);
                    });
            }
        } else {
            setEditable(false);
            setCargando(true);
        }
    }, [params, stateToken]);




    //=========================================================cerrar modal de alerta
    const handleClose = () => {
        setOpen(false);
    };

    //=========================================================funcion para cancelar y volver a la lista
    const handleCancelar = () => {
        window.history.back();
    };

    //=========================================================funcion para guardar
    const handleGuardar = () => {
        const surveyData = {
            nombre_encuesta: tituloEncuesta,
            fecha_inicio: fechaDesdeBackend,
            fecha_fin: fechaHastaBackend,
            opcion_encuesta: optionsEncuesta,
        };


        //valido que el tituloEncuesta no este vacio
        if (tituloEncuesta.trim() === '') {
            setErrorTituloEncuesta(true);
            setOpen(true);
            setSeverity('error');
            setMensaje('Por favor complete el titulo de la encuesta');
            return;
        }

        //validar la fecha desde y hasta
        if (fechaDesdeBackend === '' || fechaHastaBackend === '') {

            //valido que si la fecha desde falta completar la fecha hasta
            if (fechaDesdeBackend === '') {
                setErrorDesde(true);
            }

            if (fechaHastaBackend === '') {
                setErrorHasta(true);
            }

            setOpen(true);
            setSeverity('error');
            setMensaje('Por favor seleccione las fechas');
            return;
        }

        if (fechaDesdeBackend > fechaHastaBackend) {
            setOpen(true);
            setSeverity('error');
            setMensaje('La fecha desde no puede ser mayor a la fecha hasta');
            return;
        }




        //valido que optionsEncuesta.value no esten vacios
        const isValid = optionsEncuesta.every((option) => option.value.trim() !== '');
        if (!isValid) {

            //obtener el index de los optionsEncuesta que no tienen value
            const errorIndexs = optionsEncuesta
                .map((option, index) => (option.value.trim() === '' ? index : null))
                .filter((index) => index !== null);
            setErrorOptionsValueIndexs(errorIndexs);

            setOpen(true);
            setSeverity('error');
            setMensaje('Por favor complete todas las preguntas');
            return;
        }

        //valido que este seleccionado optionsEncuesta.selectorSelected
        const isSelected = optionsEncuesta.every((option) => option.selectorSelected.trim() !== '');
        if (!isSelected) {
            //obtener el index de los optionsEncuesta que no tienen selectorSelected
            const errorIndexs = optionsEncuesta
                .map((option, index) => (option.selectorSelected.trim() === '' ? index : null))
                .filter((index) => index !== null);
            setErrorOptionsValuesIndexs(errorIndexs);

            setOpen(true);
            setSeverity('error');
            setMensaje('Por favor seleccione una opción');
            return;
        }

        //valido que este seleccionado optionsEncuesta.selectorSelected y optionsEncuesta.options.value esten completos
        //si es igual optionsEncuesta.selectorSelected a "Seleccion unica" o "Casillas" 
        const isSelectedAndComplete = optionsEncuesta.every((option) => {
            if (option.selectorSelected === 'Selección unica' || option.selectorSelected === 'Casillas') {
                return option.options.every((opt) => opt.value.trim() !== '');
            }
            return true;
        });
        if (!isSelectedAndComplete) {
            //obtener el index de los optionsEncuesta.options.value que no tienen value === ""
            // ['0-0', '0-1', '0-2'] retorna asi
            const errorIndexs = optionsEncuesta
                .map((option, index) => {
                    if (option.selectorSelected === 'Selección unica' || option.selectorSelected === 'Casillas') {
                        return option.options
                            .map((opt, optIndex) => (opt.value.trim() === '' ? `${index}-${optIndex}` : null))
                            .filter((index) => index !== null);
                    }
                    return null;
                })
                .flat()
                .filter((index) => index !== null);
            setErrorOptionsLabelsEncuestaValueIndexs(errorIndexs);


            setOpen(true);
            setSeverity('error');
            setMensaje('Por favor complete todas las opciones');
            return;
        }




        setLoadingGuardar(true);

        if (params?.id) {
            handleApiActualizar(surveyData);
        } else {
            handleApiEnviar(surveyData);
        }




    };

    //=========================================================funcion para al darle una card nueva
    const handleAgregarCardNueva = (e) => {
        const newOption = {
            id: optionsEncuesta.length + 1,
            label: 'Ingrese pregunta',
            value: '',
            type: 'text',
            selectorSelected: 'Selección unica',
            options: [
                { id: 1, label: 'Ingresar pregunta', value: '', type: 'radio' }
            ]
        };
        setOptionsEncuesta((prevOptions) => [...prevOptions, newOption]);
        // setTituloEncuesta("");
    };


    //=========================================================funcion para al darle enter a una pregunta
    const handleEventEnter = (e, index) => {
        // if (e.key === 'Enter' && e.target.value.trim() !== '') {
        if (e.key === 'Enter') {
            const newOptionsEncuesta = [...optionsEncuesta];

            // Verifica que el índice sea válido
            if (index >= 0 && index < newOptionsEncuesta.length) {
                // Verifica que la propiedad `options` exista y sea un array
                if (!Array.isArray(newOptionsEncuesta[index].options)) {
                    newOptionsEncuesta[index].options = [];
                }

                // Crear una nueva opción
                const newOption = {
                    id: newOptionsEncuesta[index].options.length + 1, // Generar un nuevo ID
                    // label: e.target.value, // Usar el valor ingresado
                    label: 'Ingresar pregunta',
                    value: '',
                    type: newOptionsEncuesta[index].type, // Usar el tipo actual
                };


                // Agregar la nueva opción al array de opciones del objeto actual
                newOptionsEncuesta[index].options.push(newOption);
                // console.log("newOptionsEncuesta", newOptionsEncuesta);

                // Actualizar el estado
                setOptionsEncuesta(newOptionsEncuesta);

                // Limpiar el campo de entrada
                e.target.value = '';
            } else {
                console.error(`Índice inválido: ${index}`);
            }
        }
    };


    //=========================================================funcion para remover una pregunta
    const handleRemovePregunta = (index) => {
        const updatedOptions = [...optionsEncuesta];
        updatedOptions.splice(index, 1);
        setOptionsEncuesta(updatedOptions);
    };



    //=============================================funcion para seleccionar la fecha desde
    const handleFechaDesde = (event) => {
        // console.log("event", event);
        setFechaDesde(event);

        //obtener la fecha en formato YYYY-MM-DD
        let fecha = event.toISOString().split('T')[0];
        setFechaDesdeBackend(fecha);

        setErrorDesde(false);
    };


    //=============================================funcion para seleccionar la fecha hasta
    const handleFechaHasta = (event) => {
        // console.log("event", event);
        setFechaHasta(event);

        //obtener la fecha en formato YYYY-MM-DD
        let fecha = event.toISOString().split('T')[0];
        setFechaHastaBackend(fecha);

        setErrorHasta(false);
    }




    //==========================================================funcion para enviar encuesta a la api
    const handleApiEnviar = (body) => {
        postAddEncuesta(body, stateToken?.access_token)
            .then(response => {
                setLoadingGuardar(false);
                setOpen(true);
                setSeverity('success');
                setMensaje("Encuesta guardada correctamente");

                setTimeout(() => {
                    navigate('/app/admin/encuestas/listar');
                }, 1500);
            })
            .catch(error => {
                console.log("error-postAddEncuesta", error);
                setLoadingGuardar(false);
                setMensaje("Error al guardar la encuesta");
                setSeverity('error');
                setOpen(true);
            })
    };

    //==========================================================funcion para actualizar encuesta
    const handleApiActualizar = (body) => {
        postUpdateEncuesta(params.id, body, stateToken?.access_token)
            .then(response => {
                setLoadingGuardar(false);
                setOpen(true);
                setSeverity('success');
                setMensaje("Encuesta actualizada correctamente");

                setTimeout(() => {
                    navigate('/app/admin/encuestas/listar');
                }, 1500);
            })
            .catch(error => {
                console.log("error-postUpdateEncuesta", error);
                setLoadingGuardar(false);
                setMensaje("Error al actualizar la encuesta");
                setSeverity('error');
                setOpen(true);
            })
    }

    return (
        <HeaderCustom>
            <div className="min-h-screen bg-gray-100 p-4 sm:p-6">
                <div className="max-w-5xl mx-auto">
                    <div className="mb-6">
                        <h1 className="text-2xl font-bold text-gray-800 mb-1">
                            {editable ? "Editar Encuesta" : "Crear Encuesta"}
                        </h1>
                    </div>

                    {cargando ? (
                        <div className="space-y-4">
                            {/* Sección: Información */}
                            <div className="bg-white rounded-xl shadow-xl overflow-hidden">
                                <div className="p-6 border-b border-gray-200">
                                    <h2 className="text-lg font-semibold text-gray-800 mb-4">Información de la Encuesta</h2>

                                    <div className="mb-4">
                                        <FreeTextField
                                            label="Ingrese el Titulo de la Encuesta"
                                            tituloEncuesta={tituloEncuesta}
                                            setTituloEncuesta={setTituloEncuesta}
                                            setErrorTituloEncuesta={setErrorTituloEncuesta}
                                            errorTituloEncuesta={errorTituloEncuesta}
                                        />
                                    </div>

                                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mt-4">
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-2">Fecha desde</label>
                                            <LocalizationProvider adapterLocale="es" dateAdapter={AdapterDayjs}>
                                                <DatePicker
                                                    label="Fecha desde"
                                                    value={fechaDesde}
                                                    onChange={handleFechaDesde}
                                                    format="DD/MM/YYYY"
                                                    slotProps={{ textField: { size: "small", fullWidth: true, error: errorDesde } }}
                                                />
                                            </LocalizationProvider>
                                        </div>

                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-2">Fecha hasta</label>
                                            <LocalizationProvider adapterLocale="es" dateAdapter={AdapterDayjs}>
                                                <DatePicker
                                                    label="Fecha hasta"
                                                    value={fechaHasta}
                                                    onChange={handleFechaHasta}
                                                    format="DD/MM/YYYY"
                                                    slotProps={{ textField: { size: "small", fullWidth: true, error: errorHasta } }}
                                                />
                                            </LocalizationProvider>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Sección: Preguntas */}
                            <EncuestaFormComponents
                                setOptionsEncuesta={setOptionsEncuesta}
                                optionsEncuesta={optionsEncuesta}
                                handleEventEnter={handleEventEnter}
                                handleRemovePregunta={handleRemovePregunta}
                                handleAgregarCardNueva={handleAgregarCardNueva}
                                errorOptionsLabelsValueIndexs={errorOptionsLabelsValueIndexs}
                                setErrorOptionsValueIndexs={setErrorOptionsValueIndexs}
                                errorOptionsValuesIndexs={errorOptionsValuesIndexs}
                                setErrorOptionsValuesIndexs={setErrorOptionsValuesIndexs}
                                errorOptionsLabelsEncuestaValueIndexs={errorOptionsLabelsEncuestaValueIndexs}
                                setErrorOptionsLabelsEncuestaValueIndexs={setErrorOptionsLabelsEncuestaValueIndexs}
                            />

                            {/* Botones */}
                            <div className="bg-white rounded-xl shadow-md">
                                <div className="flex justify-start gap-3 p-6">
                                    <button
                                        type="button"
                                        onClick={handleGuardar}
                                        disabled={loadingGuardar}
                                        className="px-6 py-2 bg-[#104063] hover:bg-[#0d3553] disabled:opacity-70 text-white rounded-lg font-medium transition-colors"
                                    >
                                        {loadingGuardar ? "Guardando..." : "Guardar"}
                                    </button>

                                    <button
                                        type="button"
                                        onClick={handleCancelar}
                                        className="px-6 py-2 text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-lg font-medium transition-colors"
                                    >
                                        Cancelar
                                    </button>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div className="bg-white rounded-xl shadow-md p-8">
                            <div className="h-6 bg-gray-200 rounded w-1/3 mb-6 animate-pulse" />
                            <div className="space-y-4">
                                <div className="h-10 bg-gray-200 rounded animate-pulse" />
                                <div className="h-10 bg-gray-200 rounded animate-pulse" />
                                <div className="h-24 bg-gray-200 rounded animate-pulse" />
                            </div>
                        </div>
                    )}
                </div>
            </div>

            <Backdrop open={loadingGuardar} sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}>
                <CircularProgress color="inherit" />
            </Backdrop>

            <Snackbar open={open} autoHideDuration={2000} onClose={handleClose}>
                <Alert onClose={handleClose} severity={severity} elevation={6} variant="filled" >
                    {mensaje}
                </Alert>
            </Snackbar>
        </HeaderCustom>
    );
}

export default AddEncuestaPage;